import { createRouter, createWebHashHistory } from 'vue-router'
import ChordTyper from '../views/ChordTyper'

const routes = [
  {
    path: '/',
    redirect: '/ChordTyper'
  },
  {
    path: '/ChordTyper',
    name: 'ChordTyper',
    component: ChordTyper
  },
  {
    path: '/ChordDict',
    name: 'ChordDict',
    component: () => import(/* webpackChunkName: "about" */ '../views/ChordDict')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
